import { render, staticRenderFns } from "./step_banking-security_scalable.vue?vue&type=template&id=3905865a&scoped=true"
import script from "./step_banking-security_scalable.vue?vue&type=script&lang=js"
export * from "./step_banking-security_scalable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3905865a",
  null
  
)

export default component.exports